<template>
<svg width="17" height="4" viewBox="0 0 17 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17 0H0V4H17V0Z" fill="currentColor"/>
</svg>
</template>